import { parseCSV } from '@/features/studies/utils/parseParticipantsCsv';
import { useNotification } from '@refinedev/core';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

export const useParseParticipantCsv = () => {
  const { t } = useTranslation();
  const { open: openNotification } = useNotification();

  const { mutateAsync: parseParticipantCsv, isLoading } = useMutation({
    mutationFn: async (file: File) => {
      const result = await parseCSV(file);
      return result;
    },
    onSuccess: () => {
      openNotification?.({
        type: 'success',
        message: t('pages.studies.success.csvUploaded'),
      });
    },
    onError: (error) => {
      openNotification?.({
        type: 'error',
        message:
          error === 'INVALID_CSV_DATA'
            ? t('pages.studies.errors.invalidCsvData')
            : t('pages.studies.errors.unexpectedError'),
      });
    },
  });

  return { parseParticipantCsv, isLoading };
};
